// extracted by mini-css-extract-plugin
module.exports = {"divider":"itemFlow_document_divider__Ubyke","wrapper":"itemFlow_document_wrapper__3fjsn"};